/**
 * Z4-Lib RUM instance holder. The instance is set from the entry point via initZ4Rum.
 * Only setZ4RumInstance and flushZ4Rum are exposed; no direct aws-rum-web init.
 */

let rumInstance: { dispatch?: () => void } | null = null;

export function setZ4RumInstance(rum: { dispatch?: () => void } | null): void {
  rumInstance = rum;
}

export function flushZ4Rum(): void {
  rumInstance?.dispatch?.();
}
